import React from 'react';
import { connect } from 'react-redux';
import { GFInitialState, GFUser } from '../../models/models';
import { selectIsStudent } from '../../reducers/userReducer';

interface Props {
  user: GFUser;
  isStudent: boolean;
}

interface State {
  isAdded: boolean;
}

class Chat extends React.Component<Props, State> {
  private timeout: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      isAdded: false,
    }
  }

  componentDidMount() {
    this.addChat();
  }

  componentDidUpdate() {
    this.addChat();
  }

  shouldAddChat = () => {
    if (this.props.isStudent) {
      return false;
    }

    return this.props.user.isActive && this.props.user.paymentPlan === 'trial';
  }

  addChat = () => {
    if (! this.shouldAddChat()) {
      clearTimeout(this.timeout);
      return;
    }

    if (this.timeout) {
      return;
    }

    if (this.state.isAdded) {
      return;
    }

    this.timeout = setTimeout(() => {
      this.setState({ isAdded: true });

      const script = document.createElement("script");
      script.src = "//js.hs-scripts.com/48711788.js";
      script.async = true;
      script.defer = true;
      script.id = "hs-script-loader";

      document.body.appendChild(script);
    }, 1000);
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state: GFInitialState, ownProps: any) => {
  return {
    user: state.user,
    isStudent: selectIsStudent(state),
  };
};

export default connect(mapStateToProps, {})(Chat);
